import appConfig from '@/config/appConfig.typed';
import uaUtils from '@/utils/uaUtils';

const isConnectionEnabled = () => {
    const connectionAvailabilityList = appConfig.getConnectionAvailabilityList();

    return isAvailableAny(connectionAvailabilityList);
};

const isAvailableAny = (list) => {
    if (!list) return false;

    const osName = uaUtils.getOSName();

    //check enabled device types
    return list.some((config) => {
        const {enabledOsName, bleDeviceTypes, usbDeviceTypes} = config;

        if (enabledOsName && enabledOsName.toLowerCase() !== osName) return false;

        return !!bleDeviceTypes?.length || !!usbDeviceTypes?.length;
    });
};

const isAvailablePerDevice = (list, deviceType, isBle) => {
    if (!list) return false;

    const osName = uaUtils.getOSName();

    //check disabled device types
    for (const config of list) {
        const {disabledOsName, bleDeviceTypes, usbDeviceTypes} = config;
        const deviceTypes = isBle ? bleDeviceTypes : usbDeviceTypes;

        if (disabledOsName && disabledOsName.toLowerCase() === osName) {
            const isDeviceTypeDisabled = deviceTypes?.some((x) => x.deviceType === deviceType);

            //if device type exists then return false because device type is disabled for that OS name
            if (isDeviceTypeDisabled) return false;
        }
    }

    //check enabled device types
    return list.some((config) => {
        const {enabledOsName, bleDeviceTypes, usbDeviceTypes} = config;
        const deviceTypes = isBle ? bleDeviceTypes : usbDeviceTypes;

        if (enabledOsName && enabledOsName.toLowerCase() !== osName) return false;

        return deviceTypes?.some((x) => x.deviceType === deviceType);
    });
};

export default {
    isConnectionEnabled,
    isAvailableAny,
    isAvailablePerDevice,
};
